// import { LogoutPageState, appRoutes, history } from '@cloudpremise/portal_core';
import { Middleware, MiddlewareAPI, isRejectedWithValue } from '@reduxjs/toolkit';

export const rtkQueryErrorGlobalHandler: Middleware = (_: MiddlewareAPI) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    // we got an invalid session id, so show the error (currently a page, but should be a dialog)
    // if (action.payload.status === 401) {
    //   history.navigate(appRoutes.logout, { state: { isSessionExpired: true } satisfies LogoutPageState });
    // }
  }

  return next(action);
};
